import { getAllCxAction } from "features/cx-actions/reducer/CxActionActions";
import { getAllInsights } from "features/insights/reducer/InsightActions";
import { getAllOpportunity } from "features/opportunity/reducer/OpportunityActions";
import { getAllProjects } from "features/projects/reducer/ProjectsActions";
import { getAllSolutions } from "features/solutions/reducer/SolutionsActions";
import { ActionItemCard } from "shared/components/cards/cx-cards/ActionCard";
import { InsightCard } from "shared/components/cards/cx-cards/InisightCard";
import { OpportunityItemCard } from "shared/components/cards/cx-cards/OpportunityCard";
import { ProjectItemCard } from "shared/components/cards/cx-cards/ProjectCard";
import { SolutionItemCard } from "shared/components/cards/cx-cards/SolutionCard";
import RelatedCjmsManager from "shared/components/Relations/RelatedCjmsManager";
import { ActionDropdown } from "shared/dropdowns/cx-dropdown/CxActions/ActionDropdown";
import { InsightDropdown } from "shared/dropdowns/cx-dropdown/Insights/InsightDropdown";
import { OpportunityDropdown } from "shared/dropdowns/cx-dropdown/Opportunity/OpportunityDropdown";
import { ProjectDropdown } from "shared/dropdowns/cx-dropdown/ProjectDropdown";
import { SolutionDropdown } from "shared/dropdowns/cx-dropdown/Solution/SolutionDropdown";
import { InformationType, StatusCode } from "utils/optionsSets/OptionSets";

export interface TabData {
	label: string;
	AddComponent?: React.ComponentType<any>;
	type?: (typeof TypesTabs)[keyof typeof TypesTabs] | string | undefined;
	Card: React.ComponentType<any>; // Accept any component
	componentProps?: any;
	cardProps?: any;
	swimlaneType?: number;
}
export const TypesTabs = {
	Insights: "cem_insight",
	Opportunities: "cem_cxopportunity",
	Solutions: "cem_cxsolution",
	ActionsList: "cem_cxactiontask",
	Project: "cem_project",
	RelatedCjms: "cem_customerjourney",
	CustomLibraries: "cem_custom_libraries",
};

// Example columns array with dynamic components
export const TabsData: TabData[] = [
	{
		label: "ASPX_33",
		AddComponent: InsightDropdown,
		Card: InsightCard,
		type: TypesTabs.Insights,
		swimlaneType: InformationType.Insights,
		componentProps: {
			reduxActions: [getAllInsights],
			entityType: "cem_insight",
			attributeName: "linkedInsights",
			cxAttributeID: "insightId",
			noDataIcon: "GEM",
			noDataText: "CX_COMPONENT_INSIGHT_EMPTY",
		},
	},
	{
		label: "JS_71",
		Card: RelatedCjmsManager,
		type: TypesTabs.RelatedCjms,
		cardProps: {
			attributeName: "linkedCjms",
			mapping: false,
		},
		componentProps: {
			noDataIcon: "CJM",
			noDataText: "CX_COMPONENT_CJM_EMPTY",
		},
	},
	{
		label: "SOLUTIONS",
		AddComponent: SolutionDropdown,
		Card: SolutionItemCard,
		type: TypesTabs.Solutions,
		swimlaneType: InformationType.Solution,

		componentProps: {
			asyncFns: [{ asyncFn: getAllSolutions, parameter: { statusCode: StatusCode.Active } }],
			entityType: "cem_cxsolution",
			attributeName: "linkedSolutions",
			cxAttributeID: "solutionId",
			noDataIcon: "SOLUTION",
			noDataText: "CX_COMPONENT_SOLUTION_EMPTY",
		},
	},
	{
		label: "OPPORTUNITIES",
		AddComponent: OpportunityDropdown,
		Card: OpportunityItemCard,
		type: TypesTabs.Opportunities,
		swimlaneType: InformationType.Opportunity,

		componentProps: {
			asyncFns: [{ asyncFn: getAllOpportunity, parameter: { statusCode: StatusCode.Active } }],
			entityType: "cem_cxopportunity",
			attributeName: "linkedOpportunities",
			cxAttributeID: "opportunityId",
			noDataIcon: "OPPORTUNITY",
			noDataText: "CX_COMPONENT_OPPORTUNITY_EMPTY",
		},
	},
	{
		label: "JS_80",
		AddComponent: ActionDropdown,
		Card: ActionItemCard,
		type: TypesTabs.ActionsList,
		swimlaneType: InformationType.ActionsList,
		componentProps: {
			asyncFns: [{ asyncFn: getAllCxAction, parameter: { statusCode: StatusCode.Active } }],
			entityType: "cem_cxactiontask",
			attributeName: "linkedActions",
			cxAttributeID: "cxActionId",
			noDataIcon: "MENU-ACTION",
			noDataText: "CX_COMPONENT_ACTION_EMPTY",
		},
	},
	{
		label: "PROJECTS",
		AddComponent: ProjectDropdown,
		Card: ProjectItemCard,
		type: TypesTabs.Project,
		swimlaneType: InformationType.Project,
		componentProps: {
			reduxActions: [getAllProjects],
			entityType: "cem_cxproject",
			attributeName: "linkedProjects",
			cxAttributeID: "cxProjectId",
			noDataIcon: "PROJECT",
			noDataText: "CX_COMPONENT_PROJECT_EMPTY",
		},
	},
];
